import { ReactNode } from "react";
import cx from "classnames";

import TileWrapper from "ds/components/Tile/Wrapper";
import Box from "ds/components/Box";
import { Cross } from "components/icons/generated";
import ButtonIcon from "ds/components/ButtonIcon";

import { getDismissButtonVariant } from "./utils";
import styles from "./styles.module.css";

export enum AnnouncementTileBackgroundType {
  Clouds = "clouds",
  Planets = "planets",
  IacConf = "iacConf",
}

type AnnouncementTileProps = {
  children: ReactNode;
  className?: string;
  backgroundType: AnnouncementTileBackgroundType;
  onDismiss?: () => void;
};

const AnnouncementTile = ({
  children,
  backgroundType,
  className,
  onDismiss,
}: AnnouncementTileProps) => {
  return (
    <TileWrapper
      grow="0"
      noBorder
      direction="column"
      className={cx(
        styles.announcement,
        styles[backgroundType],
        onDismiss && styles.dismissible,
        className
      )}
    >
      {onDismiss && (
        <Box padding="x-large x-large 0 x-large" justify="end">
          <ButtonIcon
            variant={getDismissButtonVariant(backgroundType)}
            className={styles.dismissButton}
            onPress={onDismiss}
            icon={Cross}
          >
            Dismiss
          </ButtonIcon>
        </Box>
      )}
      <Box padding={onDismiss ? "x-large xx-large xx-large xx-large" : "xx-large"}>{children}</Box>
    </TileWrapper>
  );
};

export default AnnouncementTile;
